console.log('process.env.',process.env);
export const ASSETS_BASE_URL = process.env.ASSETS_BASE_URL;